<template>
    <div class="d-flex justify-content-between vh-100 overflow-auto flex-column">

        <!-- Header -->
        <div class="authentication-header">
        <div class="container">
            <div class="col-md-12">
                <div class="text-center">
                    <img src="@/assets/img/logo.svg" alt="logo">
                </div>
            </div>
        </div>
        </div>	
        <!-- /Header -->

        <!-- Main Wrapper -->
        <div class="main-wrapper">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-5 mx-auto">
                    <form action="otp-phone">
                        <div class="d-flex flex-column justify-content-center">
                            <div class="card p-sm-4 my-5">
                                <div class="card-body">
                                    <div class="text-center mb-3">
                                        <h3 class="mb-2">Forgot Password?</h3>
                                        <p>Enter your email, we will send you a otp to reset your password.</p>
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label">Email</label>
                                        <input type="email" class="form-control">
                                    </div>
                                    <div class="mb-3">
                                        <button type="submit" class="btn btn-lg btn-linear-primary w-100">Submit</button>
                                    </div>
                                    <div class=" d-flex justify-content-center">
                                        <p>Remember Password? <router-link to="/" class="text-primary">Sign In</router-link></p>
                                    </div>
                                    <div>
                                        <img src="@/assets/img/bg/authentication-bg.png" class="bg-left-top" alt="Img">
                                        <img src="@/assets/img/bg/authentication-bg.png" class="bg-right-bottom" alt="Img">
                                    </div>
                                </div>
                            </div>					
                        </div>
                    </form>
                </div>
            </div>
        </div>
        </div>
        <!-- /Main Wrapper -->

        <!-- Footer -->
        <div class="footer-copyright  bg-transparent">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <p>Copyright &copy; 2024. All Rights Reserved Truelysell</p>
                </div>
            </div>
        </div>
        </div>
        <!-- /Footer -->	

    </div>
</template>